<template>
  <div>
    <selled-detail :list="orderinfoList" v-transition></selled-detail>
  </div>
</template>

<script>
import SelledDetail from './components/Content'
export default {
  name: 'SelledOrderdetail',
  components: {
    SelledDetail
  },
  data () {
    return {
      orderinfoList: {},
      orderid: decodeURIComponent(this.$route.query.orderid)
    }
  },
  methods: {
    getOrderinfoInfo () {
      this.axios.get('/ApiMySelledDetail/Detail/' + this.orderid)
        .then(this.getOrderinfoInfoSucc)
        .catch(this.getOrderinfoInfoFail)
    },
    getOrderinfoInfoSucc (res) {
      res = res.data
      if (res.ret) {
        if (res.errorInfo === '') {
          const data = res.data
          this.orderinfoList = JSON.parse(data.orderinfoList)
        } else {
          alert(res.errorInfo)
        }
      }
    },
    getOrderinfoInfoFail (err) {
      console.log(err)
    }
  },
  mounted () {
    this.getOrderinfoInfo()
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/selled_detail/Detail.vue